import { mixpanel, optimove, ga } from 'js/analytics/adapters'
import flowNames from './flowNames'

export const trackStartRegistration = ({ entryPoint, flowName } = {}) => {
  if (!flowNames.includes(flowName)) {
    console.warn(`"${flowName}" is not a known flow name`)
  }

  mixpanel.track('Start Registration', {
    'Entry Point': entryPoint,
    'Flow Name': flowName,
  })
  ga.track('Start Registration')
  optimove.track('start_registration', { entry_point: entryPoint })
}
